function Tab({ selected, nrTabs, onClick, children, mobile = null }) {
  const layoutClasses = `relative min-w-0 flex-1 items-center px-3 py-2.5 text-left text-sm font-medium text-white first:rounded-tl-xl last:rounded-tr-xl md:px-4 ${
    mobile ? "flex md:hidden" : "flex"
  }`;

  if (nrTabs === 1) {
    return <div className={`${layoutClasses} bg-altblue-500`}>{children}</div>;
  }

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={`${layoutClasses} focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
        selected ? "bg-altblue-600" : "bg-altblue-500 hover:text-altgray-300"
      }`}
    >
      {children}
    </button>
  );
}

function Tabs({ children, nrTabs }) {
  return (
    <div
      className={`flex w-full shrink-0 rounded-t-xl border-b-2 bg-altblue-500 ${
        nrTabs === 1 ? "border-altblue-500" : "border-altblue-600"
      } ${nrTabs > 2 ? "divide-x-2 divide-altblue-600" : ""}`}
    >
      {children}
    </div>
  );
}

Tabs.Tab = Tab;

export default Tabs;
